import { DcBaseComponent } from '@deleteagency/dc';

export default class SearchDetailsCollapsedComponent extends DcBaseComponent {
    static getNamespace() {
        return 'search-details-collapsed';
    }

    static getRequiredRefs() {
        return ['show', 'hide', 'content'];
    }

    onInit() {
        this._isExpanded = false;
        this.addListener(this.refs.show, 'click', this._onShowClick);
        this.addListener(this.refs.hide, 'click', this._onHideClick);
    }

    _onHideClick = () => {
        if (this._isExpanded) {
            this._collapse();
            this._isExpanded = false;
        }
    };

    _onShowClick = () => {
        if (!this._isExpanded) {
            this._expand();
            this._isExpanded = true;
        }
    };

    _expand() {
        this.refs.content.classList.add('is-expanded');
        this.refs.show.classList.add('is-hidden');
        this.refs.hide.classList.remove('is-hidden');
    }

    _collapse() {
        this.refs.content.classList.remove('is-expanded');
        this.refs.hide.classList.add('is-hidden');
        this.refs.show.classList.remove('is-hidden');
    }
}
